import {
    GET_ADMIN_ACCESS_BY_ADMIN_ID,
    CREATE_ADMIN_ACCESS,
    UPDATE_ADMIN_ACCESS,
    UPDATE_ADMIN_ROLE,
    UPDATE_FEATURE_ACCESS,
    OPEN_ADMIN_ACCESS_DIALOG,
    CLOSE_ADMIN_ACCESS_DIALOG,
} from "./types";

const initialState = {
    adminAccess: null,
    dialog: false,
    dialogData: null, // Contains the admin info for which we're managing access
    loading: false,
};

const adminAccessReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ADMIN_ACCESS_BY_ADMIN_ID:
            return {
                ...state,
                adminAccess: action.payload,
                loading: false,
            };
        case CREATE_ADMIN_ACCESS:
            return {
                ...state,
                adminAccess: action.payload,
            };
        case UPDATE_ADMIN_ACCESS:
        case UPDATE_ADMIN_ROLE:
        case UPDATE_FEATURE_ACCESS:
            return {
                ...state,
                adminAccess: action.payload,
            };
        case OPEN_ADMIN_ACCESS_DIALOG:
            return {
                ...state,
                dialog: true,
                dialogData: action.payload || null,
                adminAccess: null,
                loading: true,
            };
        case CLOSE_ADMIN_ACCESS_DIALOG:
            return {
                ...state,
                dialog: false,
                dialogData: null,
                adminAccess: null,
                loading: false,
            };

        default:
            return state;
    }
};

export default adminAccessReducer;
